import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { Hero } from 'shared/layout/Hero'
import { Container } from 'shared/layout/Container'
import { RichTextArea } from 'experiences/shared/RichTextArea'
import { Text, View } from 'reshaped/bundle'

export const DisclosurePage = () => {
	const pageResources = useContentfulResourcesMapped()

	return (
		<>
			<Hero>
				<Text as="h1" variant="title-1">
					Advertiser Disclosure
				</Text>
			</Hero>
			<Container>
				<View paddingBlock={{ s: 3, m: 5 }}>
					<RichTextArea document={ResourceUtils(pageResources['disclosure.content']).getRichContent()} />
				</View>
			</Container>
		</>
	)
}
